/* A file's size and kind the way chips show them — for a File in the composer and for a
   chat file the server sent back alike. */

const IMAGE_EXTS = new Set(["png", "jpg", "jpeg", "gif", "webp", "svg", "heic", "avif", "bmp"]);

/** FileTypeIcon understands raw extensions; only images need the semantic kind
    (preview-thumbnail logic keys off kind === "image"). */
export const fileKind = (name: string) => {
  // `!`: split always yields at least one segment, so pop() has one.
  const e = name.split(".").pop()!.toLowerCase();
  return IMAGE_EXTS.has(e) ? "image" : e;
};

export const fileSize = (bytes: number) =>
  bytes > 1e6 ? `${(bytes / 1e6).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
